import { FC } from 'react'
import { ProfileComponent } from '../ProfileComponent'
import { useParams } from 'react-router-dom'


export const ProfileDetailPage: FC = () => {
    const { id } = useParams()
    return (
        <>
            <ProfileComponent mode='user' userProfileId={id ?? ''}  returnUrl={'/profile'} />
        </>
    )
}

